import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { adminNav } from '@/lib/navConfig';
import OutstandingPayments from '@/components/outstanding/OutstandingPayments';

export default function AdminOutstanding() {
  return (
    <AppShell nav={adminNav} title="Status Telat Pembayaran">
      <OutstandingPayments />
    </AppShell>
  );
}
